var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.741,
    height: 15,
    viewBox: "0 0 15.741 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(-1.787 -2.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M17.361,8.721l-3.449,3.362.815,4.749a.554.554,0,0,1-.8.584L9.658,15.174,5.393,17.416a.554.554,0,0,1-.8-.584L5.4,12.083,1.954,8.721a.554.554,0,0,1,.307-.945l4.767-.692,2.132-4.32a.577.577,0,0,1,.993,0l2.132,4.32,4.767.692a.554.554,0,0,1,.307.945Z",
    transform: "translate(0 0)",
    fill: "#3b56a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dea3c9cde30ebfc0f4b7904c6acb5309.svg";
export { ForwardRef as ReactComponent };